<div class="content">
  <div class="row mx-0">
    <div class="col-4 px-0 text-start">
      <h3>Consult Notes</h3>
    </div>
  </div>

  <app-consult-note-queue-settings (settingsChange)="onSettingsChange()" />
  @if (canAssignUser) {
    <app-consult-note-queue-assign-user
      [enabled]="hasConsultNoteSelection && !assigningUsers"
      [selectedCount]="consultNoteSelectionCount"
      (assignUser)="handleAssignUser($event)"
      (clearSelection)="handleClearSelection()"
      />
  }
  @if (!loadingResults) {
    <div class="mt-2">
      @if (consultNoteQueueResults.length > 0) {
        <div>
          <app-consult-note-queue-results
            [consultNoteQueueResults]="consultNoteQueueResults"
            [selectedConsultNoteIds]="selectedConsultNoteIds"
            (selectionChanged)="handleSelectionChange($event)"
            [canAssignUser]="canAssignUser"
            />
          @if (hasMoreResults) {
            <div class="text-center mb-4">
              <a href="#next" (click)="onNextClick($event)" class="load-next-consult-notes">
                View Next {{ limit }} Consult Notes
              </a>
            </div>
          }
        </div>
      } @else {
        <p class="mt-2 ms-1">No consult notes found. Try modifying the filters.</p>
      }
    </div>
  } @else {
    <div class="mt-2 ms-1"><mat-spinner diameter="30" /></div>
  }
</div>
